
import { createReducer, on, Action } from '@ngrx/store';
import { State, initialState } from './state';
import * as actions from './actions';
import { IModal } from '@shared/models';

const reducer = createReducer(
  initialState,
  on(actions.openModal, (state, { id }) => {
    const modal: IModal = {
      id,
      isVisible: true
    };

    const modals = {
      ...state.modals,
      [modal.id]: modal
    };

    return {
      ...state,
      modals
    };
  }),
  on(actions.closeModal, (state, { id }) => {
    const modals = { ...state.modals };

    delete modals[id];

    return {
      ...state,
      modals
    };
  }),
  on(actions.openToast, (state, { toast }) => {
    return {
      ...state,
      toasts: {
        ...state.toasts,
        [toast.id]: toast
      }
    };
  }),
  on(actions.closeToast, (state, { id }) => {
    const toasts = { ...state.toasts };

    delete toasts[id];

    return {
      ...state,
      toasts
    };
  }),
  on(actions.changeFeedFilter, (state, { feedType }) => {
    return {
      ...state,
      filters: {
        feed: feedType
      }
    };
  }),
  on(actions.submitForm, (state, { id, formValue }) => {
    const form = state.forms && state.forms[id];

    return {
      ...state,
      forms: {
        ...state.forms,
        [id]: {
          ...form,
          loading: true
        }
      }
    };
  }),
  on(actions.submitFormSuccess, (state, { id }) => {
    return {
      ...state,
      forms: {
        ...state.forms,
        [id]: {
          loading: false
        }
      }
    };
  }),
  on(actions.submitFormFail, (state, { id, error}) => {
    return {
      ...state,
      forms: {
        ...state.forms,
        [id]: {
          ...state.forms[id],
          loading: false,
          error
        }
      }
    };
  }),
  on(actions.destroyForm, (state, { id }) => {
    const forms = state.forms;

    delete forms[id];

    return {
      ...state,
      forms
    };
  })
);

export function uiReducer(state: State, action: Action) {
  return reducer(state, action);
}
